import { useMutation } from '@hooks/react-query';
import { ApiResult } from '@models/api';
import { fetcherMutation } from 'utils/react-query';

import {
  UploadIdentityImageParam,
  UploadIdentityImageResponse,
  UseRApplicationUploadImageOptions,
} from '../models/mutations';

function useRApplicationUploadImage(
  options: UseRApplicationUploadImageOptions = {},
) {
  return useMutation<
    ApiResult<UploadIdentityImageResponse>,
    Record<string, unknown>,
    UploadIdentityImageParam
  >({
    ...options,
    mutationFn: async ({ variables, context }) => {
      const uploadUrlFormData = new FormData();
      uploadUrlFormData.append('image_type', variables.imageType);
      uploadUrlFormData.append('file', variables.file);

      return await fetcherMutation({
        context: {
          ...context,
          path: 'common/upload',
          isFormData: true,
        },
        variables: uploadUrlFormData,
      });
    },
  });
}

export default useRApplicationUploadImage;
